import { z } from "zod";

/** Vendor Capacity Capability — 18 rolling months, supplier-editable capacity
 * fields against SAP-sourced demand. Field name `CapacityUtiliaztion` is a
 * verbatim legacy typo; target schema uses the corrected spelling internally. */
export const vccFilterSchema = z.object({
  vendorId: z.coerce.number().int().optional(),
  materialNumber: z.string().optional(),
});
export type VccFilterInput = z.infer<typeof vccFilterSchema>;

export const vccCapacityUpsertSchema = z.object({
  vendorId: z.number().int(),
  materialNumber: z.string(),
  plantId: z.number().int(),
  monthIndex: z.number().int().min(1).max(18),
  capacityQty: z.number().nonnegative().optional(),
  capacityUtilizationPct: z.number().min(0).max(999).optional(),
  reasonId: z.number().int().optional(),
  mitigationPlan: z.string().optional(),
});
export type VccCapacityUpsertInput = z.infer<typeof vccCapacityUpsertSchema>;
